export const calculatePastDaysGradient = (
  days,
  zoom,
  strokeColor = "var(--stroke)",
  dayColor = "var(--background-3)"
) => {
  let absDays = Math.abs(days);

  const dayWidth = zoom === 28 ? 72 : zoom === 14 ? 140 : 20;
  const totalWidth = dayWidth * absDays;
  const color = dayColor;

  return `repeating-linear-gradient(90deg, ${color} 0%, ${color} ${
    dayWidth - 1
  }px, ${strokeColor} 1px, ${strokeColor} ${dayWidth}px) 0 0 / ${totalWidth - 1}px 100% no-repeat,`;
};
